let defaultButtons = [
  {
    classes: ['btn', 'btn-default', 'sr-button'],
    type: 'default',
    style: {color: '#000'},
    background: {
      color: '#CCC'
    }
  },
  {
    classes: ['btn', 'btn-primary', 'sr-button'],
    type: 'primary',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-success', 'sr-button'],
    type: 'success',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-info', 'sr-button'],
    type: 'info',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-warning', 'sr-button'],
    icon: 'warning',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  },
  {
    classes: ['btn', 'btn-danger', 'sr-button'],
    type: 'danger',
    style: {color: '#FFF'},
    background: {
      color: '#FFF'
    }
  }
];

export default defaultButtons;
